import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useFullFormPageStore } from 'store/pages/quote/add-employees/full-form/pageStore';
import { toJS } from 'mobx';
import {
  PAGE_FOOTER_BACK_BTN_TEST_ID,
  PAGE_FOOTER_COMPLETE_BTN_TEST_ID,
  PAGE_FOOTER_TEST_ID,
} from '@insurancemenu/imenu-components-lib/dist/components/layouts/constants';
import { useRemoveQueryParams } from 'global/hooks/useRemoveQueryParams';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import { useNavigation } from 'global/hooks/useNavigation';
import { RouteV2Id } from 'routes/routesConfigV2';
import { FullFormTabs } from './FullFormTabs';
import { FooterStyled, ValidationErrorsStyled } from './styles';

// TESTING_POLICY: CYPRESS_ONLY

export const PageContent: React.FC = observer(() => {
  const { subscriberExists, aggregatedErrors, getInitialData, onAddAnotherEmployee, domainData, isInitialDataLoading } =
    useFullFormPageStore();

  const removeQueryParams = useRemoveQueryParams();

  const { groupId, periodId, cartId } = domainData;
  const { onBack } = useNavigation({ domainParams: { groupId, periodId, cartId } });

  async function addAnotherEmployee(): Promise<void> {
    await onAddAnotherEmployee();
    removeQueryParams(['subscriberId', 'activeTabId']);
  }

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <PageInFlowNoSidebarLayout
      contentWidth="standard"
      domainParams={{ groupId, periodId, cartId }}
      pageId={RouteV2Id.QUOTE_ADD_EMPLOYEES_FULL_FORM}
      pageHeader={{ subtitleMaxWidth: '42rem' }}
      pageFooter={
        <FooterStyled data-test-id={PAGE_FOOTER_TEST_ID}>
          <Button
            onClick={onBack}
            size="large"
            width="24rem"
            type="outlined"
            data-test-id={PAGE_FOOTER_BACK_BTN_TEST_ID}
          >
            Back
          </Button>

          <Button
            color="custom"
            customColor={colors.green[600]}
            onClick={addAnotherEmployee}
            size="large"
            disabled={!subscriberExists}
            width="24rem"
            data-test-id={PAGE_FOOTER_COMPLETE_BTN_TEST_ID}
          >
            Add Another Employee
          </Button>
        </FooterStyled>
      }
      isInitialLoading={isInitialDataLoading}
    >
      <FullFormTabs />
      <ValidationErrorsStyled
        title="Attention! Resolve the following issue(s) to continue"
        errors={aggregatedErrors.slice().map((error) => toJS(error))}
      />
    </PageInFlowNoSidebarLayout>
  );
});
